






























































































































































































































































































































































































































































































































































































































































































































import {
  defineComponent,
  reactive,
  computed,
  useContext,
  useStore,
  PropType,
  ref,
  useRouter,
  onMounted,
  onBeforeUnmount,
  watch,
} from '@nuxtjs/composition-api'
import { useVuelidate } from '@vuelidate/core'
import { debounce } from 'throttle-debounce'
import InputText from '@/components/Inputs/new-design/InputText.vue'
import InputDate from '@/components/Inputs/new-design/InputDate.vue'
import InputCheckbox from '@/components/Inputs/new-design/InputCheckbox.vue'
import InputFile from '@/components/Inputs/new-design/InputFile.vue'
import { FormMask } from '@/contracts/FormMask'
import SectionBasic from '@/components/SectionBasic.vue'
import { sectionCoreProps } from '@/mixins/sectionCore'
import {
  FILE_FORMATS,
  getValidationRules,
  MAX_FILES_SIZE,
  TYPE_GETTING_DOCUMENTS_ALTERNATE_OPTIONS,
  TYPE_GETTING_DOCUMENTS_OPTIONS,
  REPORTING_YEARS,
  MAX_FILES_COUNT,
  MAX_DOCUMENT_NUMBER_LENGTH_TO_FNS_SENDING,
} from '@/forms-data/certificate-payment/constants'
import textErrors from '@/validation/textErrors'
import NewButton from '@/components/Inputs/new-design/NewButton.vue'
import BlockPhoneConfirm from '@/components/BlockPhoneConfirmation.vue'
import { Notification } from '@/contracts/Cards'
import BlockButtons from '@/components/BlockButtons.vue'
import { ButtonAction } from '@/contracts/ButtonHeroAction'
import BlockFormSuccess from '@/components/new-design/BlockFormSuccess.vue'
import { CertificatePaymentModel } from '@/forms-data/certificate-payment/types'
import PopupCard from '@/components/Popup/PopupCard.vue'
import { useSubmitCertificatePaymentForm } from '@/forms-data/certificate-payment/services'
import BlockFormError from '@/components/BlockFormError.vue'
import Teleport from '@/components/Teleport.vue'
import submitAdapter from '@/forms-data/certificate-payment/adapters/submit-adapter'
import InputRadioButtons from '@/components/Inputs/new-design/InputRadioButtons'
import InputSelect from '@/components/Inputs/new-design/InputSelect.vue'
import { useEmailVerification } from '@/composition/useEmailVerification'
import { secondsToString } from '@/helpers/secondsToString'
import InputError from '@/components/Inputs/new-design/InputError.vue'
import { CONFIRMATION_MESSAGE_APPEAL } from '@/forms-data/constants'
import useLogUserAgreement from '@/composition/useLogUserAgreement'
import loadScriptAsync from '@/helpers/loadScriptAsync'
import useSendMcOrmEvent from '@/composition/useSendMcOrmEvent'

export default defineComponent({
  name: 'SectionFormCertificatePayment',
  components: {
    InputError,
    InputSelect,
    InputRadioButtons,
    Teleport,
    BlockFormError,
    PopupCard,
    BlockFormSuccess,
    BlockButtons,
    BlockPhoneConfirm,
    NewButton,
    InputFile,
    InputDate,
    InputText,
    InputCheckbox,
    SectionBasic,
  },
  mixins: [sectionCoreProps],
  props: {
    actionButtons: {
      type: Array as PropType<ButtonAction[]>,
      default: () => [],
    },
    agreementUrl: {
      type: String,
      default: '',
    },
    success: {
      type: Object as PropType<{
        sendToEmailDescription: string
        sendToFnsDescription: string
        personalButtonLink: string
        personalButtonText: string
        mainButtonLink: string
        mainButtonText: string
      }>,
      default: () => ({
        sendToEmailDescription: '',
        sendToFnsDescription: '',
        personalButtonLink: '',
        personalButtonText: '',
        mainButtonLink: '',
        mainButtonText: '',
      }),
    },
    reject: {
      type: Object as PropType<{ title: string; description: string }>,
      default: () => ({ title: '', description: '' }),
    },
  },
  setup(props) {
    const {
      status: emailVerificationStatus,
      errorText: emailVerificationError,
      resetStatus: resetEmailVerificationStatus,
      timer: emailVerificationResendTime,
      getEmailVerificationCode,
      sendEmailVerificationCode,
      sendError,
      verifyError,
    } = useEmailVerification()

    const emailVerificationResendTimeHumanized = computed(() =>
      secondsToString(emailVerificationResendTime.value)
    )

    const insuranceModel = reactive<CertificatePaymentModel>({
      isNotFirstRequest: false,
      previousRequest: '',
      serial: '',
      number: '',
      dateContract: '',
      name: '',
      surname: '',
      patronymic: '',
      hasPatronymic: true,
      birthday: '',
      inn: '',
      passport: '',
      passportDate: '',
      email: '',
      phone: '',
      smsCode: '',
      isPhoneVerify: false,
      isInsured: false,
      verificationCode: '',
      isEmailVerify: computed(() => emailVerificationStatus.verified),
      insuredName: '',
      insuredSurname: '',
      insuredPatronymic: '',
      hasInsuredPatronymic: true,
      insuredBirthday: '',
      insuredInn: '',
      insuredPassport: '',
      insuredPassportDate: '',
      documents: [],
      agreePrivacyData: false,
      typeGettingDocuments: null,
      reportingYear: '',
      amountPaidInsurance: '',
      countTaxRequests: '',
      isFirstTaxRequest: true,
      insuredBirthCertificate: '',
      insuredBirthCertificateDate: '',
      insuredDocumentMode: 'passport',
    })
    const rules = computed(() => getValidationRules(insuranceModel))
    const vuelidate = useVuelidate(rules, insuranceModel)
    const context = useContext()
    const store = useStore()
    const router = useRouter()
    const {
      errorSubmit,
      timeoutSubmit,
      submitCertificatePaymentForm,
      onCloseRejectionModal,
      rejectSubmit,
    } = useSubmitCertificatePaymentForm(context.$api.requests)
    const isMobile = computed(() => store.getters['mediaQuery/isMobileMq'])
    const successPopup = ref(false)
    const successRequestNumber = ref()
    const captchaWidgetId = ref(null)
    const formIsPending = ref(false)
    const captchaIsVerified = ref(false)
    const isCanTaxService = computed(
      () =>
        insuranceModel.serial.length + insuranceModel.number.length <=
          MAX_DOCUMENT_NUMBER_LENGTH_TO_FNS_SENDING &&
        Number(insuranceModel.reportingYear) >= new Date().getFullYear() - 1
    )

    const isVerificationInputVisible = computed(
      () => emailVerificationStatus.sent && !emailVerificationStatus.verified
    )

    const isVerificationBlockVisible = computed(
      () => !emailVerificationStatus.pending
    )

    const clientIp = context.store.getters['userIp/GET_USER_IP']

    const successDescriptionMessage = computed(() => {
      if (insuranceModel.typeGettingDocuments === 'email')
        return props.success.sendToEmailDescription
      if (insuranceModel.typeGettingDocuments === 'taxService')
        return props.success.sendToFnsDescription
      return ''
    })

    const successPopupData = computed(() => {
      return {
        description: successDescriptionMessage.value,
        personalButtonLink: props.success.personalButtonLink,
        personalButtonText: props.success.personalButtonText,
        mainButtonLink: props.success.mainButtonLink,
        mainButtonText: props.success.mainButtonText,
      }
    })

    const onChangeModel = (
      key: keyof typeof insuranceModel,
      value: string | boolean | File[]
    ) => {
      insuranceModel[key] = value
      if (key === 'insuredPatronymic')
        insuranceModel.hasInsuredPatronymic = true
      if (key === 'patronymic') insuranceModel.hasPatronymic = true
    }

    const onTogglePatronymic = (key: keyof typeof insuranceModel) => {
      insuranceModel[key] = !insuranceModel[key]
    }

    const onBlur = async (key: keyof typeof insuranceModel) => {
      await vuelidate.value[key].$validate()
    }

    const logUserAgreement = useLogUserAgreement()

    const sendMcOrmEvent = useSendMcOrmEvent()

    const onSubmit = async () => {
      if (vuelidate.value.$invalid) return
      formIsPending.value = true
      const { fields, files } = submitAdapter(insuranceModel)

      const formData = new FormData()
      formData.append('fields', JSON.stringify(fields))
      files.forEach((file) => formData.append('file[]', file, file.name))

      const { success, number } = await submitCertificatePaymentForm(formData)
      successPopup.value = success
      successRequestNumber.value = number || ''

      if (success) {
        logUserAgreement({
          email: insuranceModel.email,
          phone: insuranceModel.phone,
          agreement: insuranceModel.agreePrivacyData,
        })

        sendMcOrmEvent({ fields, files })
      }
      if (timeoutSubmit.value) {
        store.commit('notifications/SET_NOTIFICATION', {
          message:
            'Не удалось отправить обращение. Проверьте интернет-соединение',
          variant: 'error',
          visible: true,
        })
      }
      formIsPending.value = false
    }

    const onReloadPage = () => {
      router.app.refresh()
    }

    const onRepeatSubmit = async () => {
      onCloseRejectionModal()
      await onSubmit()
    }

    const debouncedPostVerificationCode = debounce(300, false, async () => {
      await sendEmailVerificationCode(
        insuranceModel.verificationCode,
        insuranceModel.email,
        clientIp
      )
    })

    const onSubmitPhoneCode = (value: string) => {
      onChangeModel('verificationCode', value)
      if (insuranceModel.verificationCode.length !== 4) return
      debouncedPostVerificationCode()
    }

    const onMaxFilesSize = () => {
      const notification: Notification = {
        message: textErrors.maxFileSizeGroup,
        variant: 'error',
        visible: true,
      }
      store.commit('notifications/SET_NOTIFICATION', notification)
    }

    const onMaxFilesCount = () => {
      const notification: Notification = {
        message: textErrors.maxFileCountGroup,
        variant: 'error',
        visible: true,
      }
      store.commit('notifications/SET_NOTIFICATION', notification)
    }

    const onWrongFormats = (wrongFormatFiles: File[]) => {
      const wrongFormatString = wrongFormatFiles.reduce((acc, file) => {
        return acc + ` .${/(?:\.([^.]+))?$/.exec(file.name)?.[1]}`
      }, '')
      const notification: Notification = {
        message: textErrors.fileFormat(wrongFormatString),
        variant: 'error',
        visible: true,
      }
      store.commit('notifications/SET_NOTIFICATION', notification)
    }

    const onSubmitButtonClick = () => {
      vuelidate.value.$validate()
      if (vuelidate.value.$invalid) {
        const notification: Notification = {
          message: textErrors.formRequired,
          variant: 'error',
          visible: true,
        }
        store.commit('notifications/SET_NOTIFICATION', notification)
      }
    }

    const executePhoneConfirmCaptcha = () => {
      if (captchaIsVerified.value) {
        getEmailVerificationCode(
          insuranceModel.email,
          clientIp,
          CONFIRMATION_MESSAGE_APPEAL
        )
        return
      }
      if (window?.smartCaptcha) {
        window.smartCaptcha.execute(captchaWidgetId.value)
      } else {
        captchaIsVerified.value = true
      }
    }

    watch(isCanTaxService, (value) => {
      if (value) {
        insuranceModel.typeGettingDocuments = 'email'
      }
    })

    onMounted(async () => {
      if (process.browser) {
        try {
          const src = 'https://smartcaptcha.yandexcloud.net/captcha.js'
          await loadScriptAsync(src)
          console.log('window.smartCaptcha', window.smartCaptcha)

          captchaWidgetId.value = window.smartCaptcha.render(
            'captcha-container',
            {
              sitekey: 'ysc1_NpMrqv2Uaiha8NLUlb6nD815AXyKbNF6WmQYjJTkbe297a40',
              invisible: true,
              hideShield: true,
              callback: () => {
                captchaIsVerified.value = true
                getEmailVerificationCode(
                  insuranceModel.email,
                  clientIp,
                  CONFIRMATION_MESSAGE_APPEAL
                )
              },
            }
          )
        } catch (e) {
          console.error('LOAD CAPTCHA ERROR', e)
        }
      }
    })

    onBeforeUnmount(() => {
      // Баг с закрытием модалки после перехода по ссылке, пришлось закостылить
      successPopup.value = false
      const popup = document?.querySelector('.main-layout .popup')
      popup?.remove()
    })

    const onChangeInsuredDocumentMode = (
      mode: CertificatePaymentModel['insuredDocumentMode']
    ) => {
      insuranceModel.insuredPassport = ''
      insuranceModel.insuredBirthCertificate = ''
      insuranceModel.insuredInn = ''
      insuranceModel.insuredDocumentMode = mode
    }

    const isYandexBrowser = computed(
      () => store.getters['userAgent/browserName'] === 'yandex browser'
    )

    return {
      FILE_FORMATS,
      MAX_FILES_SIZE,
      MAX_FILES_COUNT,
      TYPE_GETTING_DOCUMENTS_OPTIONS,
      TYPE_GETTING_DOCUMENTS_ALTERNATE_OPTIONS,
      REPORTING_YEARS,
      isMobile,
      FormMask,
      insuranceModel,
      vuelidate,
      rejectSubmit,
      successPopup,
      errorSubmit,
      timeoutSubmit,
      successDescriptionMessage,
      successRequestNumber,
      isCanTaxService,
      formIsPending,
      successPopupData,
      onReloadPage,
      onRepeatSubmit,
      submitCertificatePaymentForm,
      onCloseRejectionModal,
      onWrongFormats,
      onTogglePatronymic,
      onSubmitPhoneCode,
      onBlur,
      onChangeModel,
      onSubmit,
      onMaxFilesSize,
      onMaxFilesCount,
      onSubmitButtonClick,
      executePhoneConfirmCaptcha,
      emailVerificationStatus,
      emailVerificationError,
      resetEmailVerificationStatus,
      getEmailVerificationCode,
      sendEmailVerificationCode,
      emailVerificationResendTime,
      emailVerificationResendTimeHumanized,
      isVerificationInputVisible,
      isVerificationBlockVisible,
      sendError,
      verifyError,
      onChangeInsuredDocumentMode,
      isYandexBrowser,
    }
  },
})
